module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"publishVacancy":"Разместить вакансию","restore":"Восстановить","removeVacancy":"Удалить черновик","toArchive":"В архив","createCopy":"Создать копию","vacancyPublished":"Вакансия запущена","vacancyArchived":"Вакансия перемещена в архив","vacancyRestored":"Вакансия восстановлена","vacancyCopied":"Вакансия скопирована","editTest":"Редактировать тест"}}')
  delete Component.options._Ctor
}
